import BlockContent from '@sanity/block-content-to-react'

import { serializers } from '@lib/serializers'
import { SanityContentFragment } from '@data/sanity/queries/types/content'

interface ShopTemplateHeaderProps {
  title: string
  description: Array<SanityContentFragment>
}

const ShopTemplateHeader = ({
  title,
  description,
}: ShopTemplateHeaderProps) => {
  return (
    <div className="container py-12">
      <div className="max-w-[1000px] mx-auto">
        <h1 className="font-serif text-center mb-14">{title}</h1>

        <BlockContent
          renderContainerOnSingleChild
          className="rc text-center mb-4"
          blocks={description}
          serializers={serializers}
        />
      </div>
    </div>
  )
}

export default ShopTemplateHeader
